import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Assignment } from '../entity/assignment';

import { map, tap } from 'rxjs/operators';
import { toAssignmentTypeTransformer } from '../state/transformers/todo.transformers';
import { AssignmentType } from '../state/types';
import { BLService } from './bl.service';

@Injectable({
  providedIn: 'root',
})
export class AssignmentService extends BLService {
  private RESOURCE_ENDPOINT = 'assignment';

  constructor() {
    super();
    this.useCache();
  }

  getAssignments(): Observable<Assignment[]> {
    if (!this.hasCacheExpired()) {
      return this.getCacheObservable<Assignment[]>();
    }

    return this.httpGet<Assignment[]>(this.RESOURCE_ENDPOINT).pipe(tap((result) => this.updateCache(result)));
  }

  getAssignmentTypes(): Observable<AssignmentType[]> {
    return this.getAssignments().pipe(map((assignments) => assignments.map(toAssignmentTypeTransformer.transform)));
  }
}
